export default __webpack_public_path__ + "static/210511_KWM_by_Kruszewski__MK_6341-3ef94bd02b5b0ac42086dfa3ad76da77.jpg";